import { callFunction } from "./functions-client";

// Account sessions (devices signed in), backed by auth.sessions.
export interface AccountSession {
  id: string;
  user_agent: string | null;
  ip: string | null;
  created_at: string;
  updated_at: string;
  current: boolean;
}

export const listSessions = () => callFunction<{ sessions: AccountSession[] }>("identity/sessions", { method: "GET" });
export const signOutSession = (session_id: string) => callFunction<{ ok: boolean }>("identity/sign-out-session", { body: { session_id } });
export const signOutOtherSessions = () => callFunction<{ ok: boolean }>("identity/sign-out-others", { body: {} });

/** Friendly OS · browser label from a user-agent string. */
export function deviceLabel(ua: string | null): string {
  if (!ua) return "Unknown device";
  const os = /Windows/.test(ua) ? "Windows"
    : /Mac OS X|Macintosh/.test(ua) ? "macOS"
    : /iPhone/.test(ua) ? "iPhone"
    : /iPad/.test(ua) ? "iPad"
    : /Android/.test(ua) ? "Android"
    : /Linux/.test(ua) ? "Linux" : "Device";
  const browser = /Edg\//.test(ua) ? "Edge"
    : /Chrome\//.test(ua) ? "Chrome"
    : /Firefox\//.test(ua) ? "Firefox"
    : /Safari\//.test(ua) && !/Chrome/.test(ua) ? "Safari"
    : /Deno|SupabaseEdgeRuntime|node/i.test(ua) ? "API client" : "Browser";
  return `${os} · ${browser}`;
}
